<template>
  <div class="sidebar-box">
    <h6>{{ $t('ticket.detalle.detalle_factura') }}</h6>
    <DxButton v-bind="{ ...primaryButtonProps(), icon: 'fa-solid fa-magnifying-glass fa-sm' }"
      :text="$t('ticket.detalle.ver_detalle')" :class="'w-100 mt-3'" :disabled="!idFactura" @click="abrirDetalleFactura" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { DxButton } from "devextreme-vue";
import type { DetailTicketModel } from "@api/api";
import { primaryButtonProps } from "@/.shared/helpers/button-helper";
import { useModalService } from "@/.shared/services/modal-service";
import { EntidadTicketEnum } from "../models/EntidadTicketEnum";
import FacturaModalDetail from "@/.shared/components/facturas/FacturaModalDetail.vue";

const props = defineProps<{
  model: DetailTicketModel;
}>();

const modal = useModalService();

const idFactura = computed<string | null>(() => {
  const referencia = props.model.EntidadesAsociadas?.[EntidadTicketEnum.Factura]?.[0];
  if (!referencia) return null;

  return referencia.split("?")[0];
});

async function abrirDetalleFactura(): Promise<void> {
  if (!idFactura.value) return;

  await modal.showModal(
    FacturaModalDetail,
    { idFactura: idFactura.value, idTicket: props.model.Id },
    {
      showTitle: true
    }
  );
}
</script>
